import type { DateRangePresetLabel } from '@prerender/design-system/DateRangePicker';

export const DATE_RANGE_PRESETS: readonly DateRangePresetLabel[] = [
  'today',
  'this week',
  'last 7 days',
  'last 14 days',
  'last 30 days',
  'last month',
  'last 180 days',
  'this year',
  'last year',
];
